import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import ProfileImagesInput from 'components/ProfileImagesInput'

const InputProfileImages = ({ user, onChange }) => {
  const handleChange = useCallback(
    ({ id, image }) => {
      let profileImage = user.images.find(({ profileImage }) => profileImage)
      const images = user.images.map(_image => {
        if (!profileImage && _image.orderNo === 0) {
          profileImage = _image
        }

        // Ensures that the profile image is always set
        if (
          (_image.id === id && profileImage?.url) ||
          (_image.profileImage && !profileImage?.url)
        ) {
          return {
            ..._image,
            url: image,
          }
        }

        return _image
      })

      onChange({ target: { name: 'images', value: images } })
    },
    [user, onChange]
  )

  return (
    <ProfileImagesInput
      user={user}
      onImageUpdate={handleChange}
      classNames={{ container: 'md:flex-nowrap', image: '' }}
      hideRequiredImages={true}
    />
  )
}

InputProfileImages.propTypes = {
  user: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default InputProfileImages
